import React from 'react';

const Mac = (props) => (
	<svg className={'custom-icon'+(props.className ? ' '+props.className : '')} viewBox="0 0 64 64">
<g>
	<g>
		<g>
			<g>
				<path fill="#000" d="M32,0c17.7,0,32,14.3,32,32S49.7,64,32,64S0,49.7,0,32S14.3,0,32,0z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path fill="#FFFFFF" d="M49.6,44H14.4c-1.3,0-2.4-1.1-2.4-2.4V19.9c0-1.3,1.1-2.4,2.4-2.4h35.2c1.3,0,2.4,1.1,2.4,2.4v21.7
					C52,42.9,50.9,44,49.6,44z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path fill="#384454" d="M51.5,43.5h-39V20c0-1.1,0.9-2,2-2h35c1.1,0,2,0.9,2,2V43.5z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<rect x="14.5" y="20" fill="#4F617F" width="35" height="21"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<g>
					<g>
						<path fill="#6A80A0" d="M35.2,30.3c0-1.3,1-1.9,1.1-1.9c-0.6-0.9-1.5-1-1.8-1c-0.8-0.1-1.5,0.5-1.9,0.5c-0.4,0-1-0.5-1.6-0.4
							c-0.8,0-1.6,0.5-2,1.3c-0.9,1.5-0.2,3.8,0.6,5c0.4,0.6,0.9,1.3,1.5,1.3c0.6,0,0.9-0.4,1.6-0.4c0.7,0,1,0.4,1.6,0.4
							c0.7,0,1.1-0.6,1.5-1.2c0.5-0.7,0.7-1.4,0.7-1.4C36.5,32.3,35.2,31.8,35.2,30.3z"/>
					</g>
				</g>
			</g>
			<g>
				<g>
					<g>
						<path fill="#6A80A0" d="M33.9,26.6c0.3-0.4,0.6-1,0.5-1.6c-0.5,0-1.1,0.3-1.4,0.8c-0.3,0.4-0.6,1-0.5,1.5
							C33,27.3,33.6,27,33.9,26.6z"/>
					</g>
				</g>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path fill="#CCDBE2" d="M52,47H12c-2.2,0-4-1.8-4-4l0,0h48l0,0C56,45.2,54.2,47,52,47z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<path fill="#A0B5BA"
					  d="M35.6,44h-6.2c-0.3,0-0.5-0.1-0.7-0.3L28,43h9l-0.7,0.7C36.1,43.9,35.9,44,35.6,44z"/>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<circle fill="#1D2226" cx="32.5" cy="19" r="0.5"/>
			</g>
		</g>
	</g>
</g>
</svg>
)
export default Mac